import { render, staticRenderFns } from "./Notification.vue?vue&type=template&id=4ea71bc1&scoped=true&"
import script from "./Notification.vue?vue&type=script&lang=js&"
export * from "./Notification.vue?vue&type=script&lang=js&"
import style0 from "./notification.scss?vue&type=style&index=0&id=4ea71bc1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea71bc1",
  null
  
)

export default component.exports